export const HIDE_HEADER = 'HIDE_HEADER';

export const hideHeader = () => (dispatch) => {
  dispatch({
    type: HIDE_HEADER,
    payload: false,
  });
};
